// extracted by mini-css-extract-plugin
export default {"subGrid":"Details_subGrid__dGwwJ"};